import React from 'react';
import { Button } from 'react-bootstrap';
import GridOcorrencias from '~/Components/Ocorrencias/GridOcorrencias';
import moment from 'moment';

/**
 * Grid de Datas com botão Imprimir.
 */
const GridDatas = ({
  dados,
  total,
  pagina,
  dataSelecionada,
  onLinhaClick,
  onImprimir,
  onPaginaChange,
}) => {
  const colunas = [
    {
      key: 'data_ocorrencia',
      label: 'Data',
      render: (item) =>
        item.data_ocorrencia ? moment(item.data_ocorrencia).format('DD/MM/YYYY') : '',
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <strong style={{ fontSize: 13 }}>Datas</strong>
        <Button size="sm" variant="outline-primary" onClick={onImprimir}>
          Imprimir
        </Button>
      </div>
      <GridOcorrencias
        dados={dados}
        total={total}
        pagina={pagina}
        colunas={colunas}
        comSel={false}
        onLinhaClick={onLinhaClick}
        linhaSelecionada={dataSelecionada}
        chaveSelecao="data_ocorrencia"
        onPaginaChange={onPaginaChange}
      />
    </div>
  );
};

export default GridDatas;
